export default __webpack_public_path__ + "static/media/list.ebff31e5.svg";